export const SpinnerIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" style={{margin: ".2em", background: "none", display: "inline-block", shapeRendering: "auto"}} width="13px" height="13px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
            <circle cx="50" cy="50" fill="none" stroke="#FFFFFF" strokeWidth="10" r="35" strokeDasharray="164.93361431346415 56.97787143782138" transform="rotate(87.593 50 50)">
            <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
            </circle>
        </svg>
    )
};

